import React, { memo, useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import EventsTable from 'components/ui/tables/EventsTable';
import useTopPanel from 'hooks/useTopPanel';
import SearchInputNavbar from 'components/SearchInputNavbar';
import EventsFilterDrawer from 'components/dashboard/EventsFilterDrawer';

const Contracts = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setComponent(
      <div className='component-title'>{t('settings.events.title')}</div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const [refetch, setRefetch] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [open, setOpen] = useState(false);

  return (
    <div className='component-list-wrapper'>
      <div className='component-list-header mb-2'>
        <div className='header-actions-container  flex flex-row items-center'>
          <div className='header-actions filter-box flex items-center  w-full'>
            <Button
              variant='base'
              color='primary'
              startIcon={<i className='bi bi-filter' />}
              className='!mr-2'
              onClick={() => setOpenFilter(true)}
            >
              {t('common.button.filter')}
            </Button>
            <SearchInputNavbar />
          </div>
          <div className='header-actions action-buttons-box flex items-center justify-center ml-4'>
            <Button
              variant='base'
              color='info'
              className='!mr-2'
              onClick={() => {
                setRefetch(true);
              }}
              disable={`${refetch}`}
            >
              <i
                className={`bi bi-arrow-repeat${
                  refetch ? ' animate-spin' : ''
                }`}
              />
            </Button>
            <Button
              variant='base'
              color='default'
              onClick={() => setOpen(true)}
            >
              <i className='bi bi-gear' />
            </Button>
          </div>
        </div>
      </div>

      <div className='component-table-wrapper'>
        <EventsTable
          emitRefetch={{ refetch, setRefetch }}
          dataPath='admin/event/index'
          emitTableColumns={{ open, setOpen }}
          tableName='staff'
          headCells={[
            { code: 'dateTime', label: t('common.table.date') },
            { code: 'staff', label: t('common.table.staff') },
            { code: 'type', label: t('common.table.objectName') },
            { code: 'lead', label: t('common.table.name') },
            { code: 'actionType', label: t('common.table.event') },
            { code: 'previous', label: t('common.table.previous') },
            { code: 'next', label: t('common.table.next') },
          ]}
          columns={[
            { code: 'date', type: 'date' },
            { code: 'staff', type: 'nested', childStr: 'name' },
            {
              code: 'type',
              child: i18n.language,
            },
            { code: 'lead', type: 'nested', childStr: 'name' },
            { code: 'actionType' },
            { code: 'previous' },
            { code: 'next' },
          ]}
        />
      </div>
      <EventsFilterDrawer open={openFilter} setOpen={setOpenFilter} />
    </div>
  );
};

export default memo(Contracts);
